export const APP_NAME = "Payroll";

// Stessa base per axios e Socket.io. In produzione basterà cambiare la
// variabile REACT_APP_API_URL (su gestionale-gls è api.fleet-manager.it).
export const API_URL = (
  process.env.REACT_APP_API_URL || "http://localhost:3041"
).replace(/\/+$/, "");

// Pagine pubbliche dei documenti legali (sito payroll-manager.it). I testi
// da firmare non si leggono da qui ma dal backend (/api/public/contratto).
export const URL_TERMINI = "https://payroll-manager.it/termini";
export const URL_PRIVACY = "https://payroll-manager.it/privacy";

// Login con Google solo se configurato (e quindi online).
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
